import { render, staticRenderFns } from "./LoginSdkJs.vue?vue&type=template&id=8f422baa&"
import script from "./LoginSdkJs.vue?vue&type=script&lang=js&"
export * from "./LoginSdkJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f422baa')) {
      api.createRecord('8f422baa', component.options)
    } else {
      api.reload('8f422baa', component.options)
    }
    module.hot.accept("./LoginSdkJs.vue?vue&type=template&id=8f422baa&", function () {
      api.rerender('8f422baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/LoginSdkJs.vue"
export default component.exports